import { isRejectedWithValue } from '@reduxjs/toolkit';

const handle401Middleware = ({ dispatch }) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // Check for 401 status
    if (action.payload?.status === 401 && action.payload?.data.detail === "Logged in on another device. Please log in again.") {
      // Perform the necessary action for 401
      dispatch({ type: 'auth/showModal' }); // Show modal
    }
  }
  return next(action);
};

export default handle401Middleware;
